import React from 'react';

import { Queries } from '@aline/common';
import { Typography } from '@mui/material';
import { DiffView } from 'src/components/shared/DiffView';
import { makeStyles } from 'tss-react/mui';

import type { SuggestionAndStatus } from '../../../ChatPanelMarkdown';

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  sectionTitle: {
    fontStyle: 'italic',
    textDecoration: 'underline',
  },
}));

export const SuggestionItemSuggestion = React.memo(function SuggestionItemSuggestion({
  suggestionAndStatus,
}: {
  suggestionAndStatus: SuggestionAndStatus;
}): JSX.Element | null {
  const { classes } = useStyles();
  const { suggestion } = suggestionAndStatus;

  return (
    <div className={classes.container}>
      <Typography className={classes.sectionTitle}>Suggestion:</Typography>
      <DiffView changes={Queries.getAlineChanges(suggestion.original, suggestion.suggested)} />
    </div>
  );
});
